var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "reveal delete-confirm-model",
      attrs: { id: "deleteConfirmModal", "data-reveal": "" },
    },
    [
      _c("div", { staticClass: "delete-modal" }, [
        _c("p", { staticClass: "font-bold" }, [
          _vm._v(_vm._s(_vm.$t("deleteConfirmMsg"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "div",
            {
              staticClass: "btn--orange",
              on: {
                click: function ($event) {
                  return _vm.confirmDelete()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.delete")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn--darkblue",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }